module.exports = __webpack_public_path__ + "static/img/2.e128648.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R407C/2.jpg
// module id = aZ8U
// module chunks = 1